export default __webpack_public_path__ + "static/media/microbiology.5f0750a3.jpg";